import { defineMessages } from 'react-intl'

const workoutMessages = defineMessages({
  viewWorkoutInApp: {
    id: 'workouts.viewWorkoutInApp',
    defaultMessage: 'View Workout In App'
  },
  findOtherWorkouts: {
    id: 'workouts.findOtherWorkouts',
    defaultMessage: 'Find Other Workouts'
  },
  complete: {
    id: 'workouts.complete',
    defaultMessage: 'Complete'
  },
  viewWorkout: {
    id: 'workouts.viewWorkout',
    defaultMessage: 'View Workout'
  },
  workoutNotFound: {
    id: 'workouts.workoutNotFound',
    defaultMessage: 'Workout Not Found'
  },
  setValue: {
    id: 'workouts.setValue',
    defaultMessage: 'Set Value'
  },
  setType: {
    id: 'workouts.setType',
    defaultMessage: 'Set Type'
  },
  noEquipment: {
    id: 'workouts.noEquipment',
    defaultMessage: 'No equipment'
  },
  weight: {
    id: 'workouts.weight',
    defaultMessage: 'Weight'
  },
  menu: {
    id: 'workouts.menu',
    defaultMessage: 'Menu'
  },
  renameSection: {
    id: 'workouts.renameSection',
    defaultMessage: 'Rename Section'
  },
  copySection: {
    id: 'workouts.copySection',
    defaultMessage: 'Copy Section'
  },
  deleteRound: {
    id: 'workouts.deleteRound',
    defaultMessage: 'Delete round'
  },
  convertToStandard: {
    id: 'workouts.convertToStandard',
    defaultMessage: 'Convert to standard'
  },
  convertToCircuit: {
    id: 'workouts.convertToCircuit',
    defaultMessage: 'Convert to circuit'
  },
  cancel: {
    id: 'workouts.cancel',
    defaultMessage: 'Cancel'
  },
  done: {
    id: 'workouts.done',
    defaultMessage: 'Done'
  },
  deleteSection: {
    id: 'workouts.deleteSection',
    defaultMessage: 'Delete section'
  },
  addExercise: {
    id: 'workouts.addExercise',
    defaultMessage: 'Add Exercise'
  },
  exercises: {
    id: 'workouts.exercises',
    defaultMessage: 'Exercises'
  },
  startWorkout: {
    id: 'workouts.starrtWorkout',
    defaultMessage: 'Start Workout'
  },
  round: {
    id: 'workouts.round',
    defaultMessage: 'Round'
  },
  add: {
    id: 'workouts.add',
    defaultMessage: 'Add'
  },
  addExerciseAllSet: {
    id: 'workouts.addExerciseAllSet',
    defaultMessage: 'Add Exercise Note (All Sets)'
  },
  exercise: {
    id: 'workouts.exercise',
    defaultMessage: 'Exercise'
  },
  noExerciseFound: {
    id: 'workouts.noExerciseFound',
    defaultMessage: 'No exercise found.'
  },
  goal: {
    id: 'workouts.goal',
    defaultMessage: 'Goal'
  },
  workoutsLoggedPerDay: {
    id: 'workouts.workoutsLoggedPerDay',
    defaultMessage: 'WORKOUTS LOGGED PER DAY'
  },
  caloriesBurned: {
    id: 'workouts.caloriesBurned',
    defaultMessage: 'Calories burned per day'
  },
  trainingVolume: {
    id: 'workouts.trainingVolume',
    defaultMessage: 'Training Volume per day'
  },
  averageDuration: {
    id: 'workouts.averageDuration',
    defaultMessage: 'Avg Duration'
  },
  averageVolume: {
    id: 'workouts.averageVolume',
    defaultMessage: 'Avg Volume'
  },
  averageCalories: {
    id: 'workouts.averageCalories',
    defaultMessage: 'Avg Calories'
  },
  addWeight: {
    id: 'workouts.addWeight',
    defaultMessage: 'Add Weight'
  },
  tryWorkout: {
    id: 'workouts.tryWorkout',
    defaultMessage: 'See Workouts'
  },
  count: {
    id: 'workouts.Count',
    defaultMessage: 'Count'
  },
  volume: {
    id: 'workouts.volume',
    defaultMessage: 'Volume'
  },
  calories: {
    id: 'workouts.calories',
    defaultMessage: 'Calories'
  },
  ifYouLeaveWithourLogging: {
    id: 'workouts.ifYouLeaveWithourLogging:',
    defaultMessage: 'If you leave without completing your workout, it will be discarded.'
  },
  markAsCompleted: {
    id: 'workouts.logWorkout',
    defaultMessage: 'Mark as completed'
  },
  discard: {
    id: 'workouts.discard',
    defaultMessage: 'Discard'
  },
  confirm: {
    id: 'workouts.confirm',
    defaultMessage: 'Confirm'
  },
  achievements: {
    id: 'workouts.achievements',
    defaultMessage: 'Achievements'
  },
  completeWorkouts: {
    id: 'workouts.completeWorkouts',
    defaultMessage: 'Complete {count} workouts'
  },
  close: {
    id: 'workouts.close',
    defaultMessage: 'Close'
  },
  continue: {
    id: 'workouts.continue',
    defaultMessage: 'Continue'
  },
  workoutAchievements: {
    id: 'workout.workoutAchievements',
    defaultMessage: 'workout achievements'
  },
  createExercise: {
    id: 'workout.createExercise',
    defaultMessage: 'Create Exercise'
  },
  primaryMuscle: {
    id: 'workout.primaryMuscle',
    defaultMessage: 'Primary Muscle'
  },
  secondaryMuscle: {
    id: 'workout.secondaryMuscle',
    defaultMessage: 'Secondar Muscle'
  },
  uploadVideo: {
    id: 'workout.uploadVideo',
    defaultMessage: 'Upload Video'
  },
  equipment: {
    id: 'workout.equipment',
    defaultMessage: 'Equipment'
  }
})
export default workoutMessages
